<script setup>
import { HRow } from '@pixul/hephaestus';
</script>

<template>
  <HRow
    v-if='currentVersion !== lastVersion'
    class='version-alert background--blue-500 padding-10'
    justify-content='center'
  >
    <div class='text-white'>
      <span>{{ $t('versionAlert.alert', { version : lastVersion }) }}</span>
      <a
        class='version-alert__link text-bold'
        @click='reload'
      >{{ $t('versionAlert.click') }}</a>
    </div>
  </HRow>
</template>

<script>
import Ky     from 'ky';
import Config from '@/config';

export default {
  name : 'VersionAlert',

  data() {

    return {
      lastVersion    : '',
      currentVersion : '',
      timerId        : undefined
    };
  },

  async created() {

    await this.getLastVersion();
    this.currentVersion = Config.version;

    this.timerId = setInterval(this.getLastVersion, 300000);
  },

  beforeUnmount() {

    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },

  methods : {
    async getLastVersion() {

      const data = await Ky.get('/version.json').json();
      this.lastVersion = data.version;
    },

    reload() {

      window.location.reload(true);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.version-alert {
  z-index: 3;
}

.version-alert__link {
  color: white;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
